module.exports = __webpack_public_path__ + "assets/images/home/placeholder.bde6d1ac02c4848e4c661e5beee2b1fc.webp";